import script from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsList.vue?vue&type=style&index=0&id=67df4611&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67df4611"]])

export default __exports__